var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "nav location-nav display_flex_evenly"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: _vm.locationUrlPrefix + '/flexibility'
      },
      "custom": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var href = _ref.href,
          route = _ref.route,
          navigate = _ref.navigate;
        return [_c('a', {
          staticClass: "nav-link",
          class: [_vm.isRouteActive(route) && 'router-link-exact-active'],
          attrs: {
            "title": _vm.$t('floating_bar_options.flexibility'),
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('FlexibilityIcon', {
          staticClass: "icon",
          staticStyle: {
            "height": "25px"
          }
        })], 1)];
      }
    }])
  })], 1), _c('li', {
    staticClass: "nav-item"
  }, [_c('div', {
    staticClass: "nav-link cursor-pointer alert-indicator",
    attrs: {
      "title": _vm.$t('floating_bar_options.notifications')
    },
    on: {
      "click": _vm.openNotificationsModal
    }
  }, [_c('span', {
    staticClass: "icon icon-bell"
  }), _vm.notificationCount > 0 ? _c('span', {
    staticClass: "alarms-count"
  }, [_vm._v(_vm._s(_vm.notificationCount))]) : _vm._e()])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }